module.exports = __webpack_public_path__ + "img/homeBg.a86875ce.png";